import React, { useEffect, useState } from 'react';

// 인증서 만료 알림.
//
// 만료는 조용하다. 서버에서 curl 하면 200 이 나오고 브라우저만 막는다.
// 2026-09-20 에 훑어 보니 말복은 11일, 노드마스터는 171일, 스카이넷은 374일
// 지난 인증서를 물고 있었다 — 아무도 몰랐다.
//
// 만료됐거나 2주 안에 만료될 것이 있을 때만 뜬다. 평소에는 아무것도 그리지
// 않는다. 늘 떠 있으면 아무도 안 본다.

const TONE = {
  expired: { bg: 'rgba(248,113,113,0.18)', border: 'rgba(248,113,113,0.4)', fg: '#fca5a5', icon: '🔒' },
  urgent: { bg: 'rgba(251,191,36,0.18)', border: 'rgba(251,191,36,0.4)', fg: '#fbbf24', icon: '⏳' },
};

const 남은날 = (d) => (d < 0 ? `${-d}일 지남` : d === 0 ? '오늘 만료' : `${d}일 남음`);

export default function CertBanner() {
  const [rows, setRows] = useState([]);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    let alive = true;
    fetch('/api/admin/server/certs', { credentials: 'include' })
      .then(r => r.json())
      .then(d => {
        if (!alive || !d?.success) return;
        // 서버 이름을 붙여 한 줄로 편다. 어느 서버인지 모르면 찾아가지 못한다.
        const flat = (d.servers || []).flatMap(s =>
          (s.certs || [])
            .filter(c => c.severity === 'expired' || c.severity === 'urgent')
            .map(c => ({ ...c, serverName: s.serverName || s.serverId })));
        flat.sort((a, b) => a.daysLeft - b.daysLeft);
        setRows(flat);
      })
      .catch(() => {});
    return () => { alive = false; };
  }, []);

  if (rows.length === 0) return null;

  const worst = rows[0].severity;
  const tone = TONE[worst] || TONE.urgent;
  const expired = rows.filter(r => r.severity === 'expired').length;

  return (
    <div style={{
      marginBottom: 14, padding: '12px 16px', borderRadius: 12,
      background: tone.bg, border: `1px solid ${tone.border}`,
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 14, flexWrap: 'wrap' }}>
        <span style={{ fontSize: '1.4rem' }}>{tone.icon}</span>
        <div style={{ flex: 1, minWidth: 220 }}>
          <div style={{ fontSize: '0.92rem', fontWeight: 700, color: tone.fg }}>
            인증서 {rows.length}건 주의
            {expired > 0 && ` · 만료됨 ${expired}건`}
          </div>
          <div style={{ fontSize: '0.78rem', color: 'rgba(255,255,255,0.55)', marginTop: 2 }}>
            {rows.slice(0, 2).map(r => `${r.serverName}: ${r.commonName} (${남은날(r.daysLeft)})`).join(' / ')}
          </div>
        </div>
        <button type="button" onClick={() => setOpen(o => !o)} style={{
          padding: '7px 14px', borderRadius: 8, border: '1px solid rgba(255,255,255,0.18)',
          background: 'rgba(255,255,255,0.06)', color: '#fff', fontFamily: 'inherit',
          fontSize: '0.8rem', fontWeight: 600, cursor: 'pointer',
        }}>{open ? '접기' : '전체 보기'}</button>
      </div>

      {open && (
        <div style={{ marginTop: 12, borderTop: '1px solid rgba(255,255,255,0.12)', paddingTop: 10 }}>
          {rows.map((r) => (
            <div key={`${r.serverName}-${r.file}`} style={{
              display: 'flex', gap: 10, alignItems: 'baseline', flexWrap: 'wrap',
              padding: '6px 0', fontSize: '0.8rem', color: 'rgba(255,255,255,0.8)',
            }}>
              <strong style={{ color: TONE[r.severity]?.fg || '#fff', minWidth: 78 }}>
                {남은날(r.daysLeft)}
              </strong>
              <span style={{ minWidth: 120 }}>{r.serverName}</span>
              <span style={{ minWidth: 150 }}>{r.commonName}</span>
              {/* 어느 주소가 물려 있는지까지 보여 준다. 만료만 알면 "그래서
                  뭐가 안 되는데?" 를 다시 찾아야 한다. */}
              <span style={{ flex: 1, color: 'rgba(255,255,255,0.5)', minWidth: 200 }}>
                {r.names.length ? r.names.join(', ') : '(쓰는 곳 없음)'}
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
